import React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '../../../store';
import LinkedComponent from '../../../components/linked-component';
import { DataElementContext } from '../../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

const DataListItemDiv = styled.div((props) => props.$styleText);

export const DataListItem = (componentProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  let isVisible = true;

  [props, isVisible] = processComponentProps(props, dataElementContext);

  const components = useAppSelector((state) => state.templatesConfig.components);

  let content = componentProps.children;

  if (props.cmId) {
    if (components[props.cmId] != null) {
      content = <LinkedComponent componentId={props.cmId} />;
    } else {
      content = null;
    }
  }

  if (!isVisible) {
    return null;
  }

  const classes = [];
  if (props.className) classes.push(props.className);
  if (props.rClassName) classes.push(props.rClassName);

  return (
    <DataListItemDiv
      className={classes.join(' ')}
      $styleText={props.styleText}
      style={props.style}
    >
      {content}
    </DataListItemDiv>
  );
};
